import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Card, CardActions,
  CardBody,
  CardContent,
  CardTitle,
  Checkbox,
  Typography,
  Radio,
  RadioGroup,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { TableDataShape } from '../../shapes/TableData';
import { NO, YES } from '../../constants';
import { BannerContext } from '../../contexts/BannerContext';

export const learnMoreButton = 'learn-more-button';
function TableRow(tableData, setTableData, setSelected,
  isProXtra, isLangPref, preferences, telemarketingCard) {

  const {
    openSmsTelemarketingInfoAlert,
  } = React.useContext(BannerContext);

  const [preference, setPreference] = React.useState(preferences);

  useEffect(() => {
    setPreference(preferences);
  }, [preferences]);

  return (title) => {
    const {
      subText,
      value
    } = tableData[title];

    const handleChange = (event) => {
      setSelected(event.target.value);
      setPreference(event.target.value);
    };

    function displayOptOutCard(type) {
      return (
        <Card>
          <CardTitle
            headerVariant="h5"
            header={(
              <Typography
                variant="h5"
                weight="base"
                height="snug"
                lineClamp="3"
              >
                {type}
              </Typography>
            )}
          />
          <CardBody>
            <Typography>
              You have previously opted out of {type.toLowerCase()}.
            </Typography>
          </CardBody>
        </Card>
      );
    }

    function determineButton(inputAttributes, checked, onChange, preferenceInput) {
      if (isLangPref) {
        return (
          <RadioGroup
            orientation="horizontal"
            aria-labelledby="language-horizontal-radio-buttons-group-label"
            name="horizontal-language-buttons-group"
            style={{
              flexWrap: 'nowrap',
            }}
            value={preference}
            onChange={handleChange}
          >
            <SelectionControlLabel value="ENG" label="English">
              <Radio
                inputAttributes={preferenceInput}
                id="ENG"
              />
            </SelectionControlLabel>
            <SelectionControlLabel value="SPAN" label="español">
              <Radio
                inputAttributes={preferenceInput}
                id="SPAN"
              />
            </SelectionControlLabel>

          </RadioGroup>
        );
      }
      return (
        <Checkbox
          inputAttributes={inputAttributes}
          checked={checked}
          onChange={onChange}
        />
      );
    }

    function shouldInfoAlertRender(oldTableData, checked) {
      if (Object.keys(oldTableData).length === 3 && !checked) {
        openSmsTelemarketingInfoAlert();
      }
    }

    const onChange = (event) => {
      const newTableData = tableData;
      const checked = event.target.checked;
      shouldInfoAlertRender(tableData, checked);
      newTableData[title].value = checked ? YES : NO;
      setTableData({ ...tableData, ...newTableData });
      setSelected((selected) => {
        if (selected.includes(title)) {
          return selected.filter((element) => element !== title);
        }
        return [...selected, title];
      });
    };

    const checked = value === YES;
    const inputAttributes = { 'aria-label': `checkbox-${title}` };
    const preferenceInput = { 'aria-label': `radio-button-${title}` };
    const isTelephone = tableData[title].type === 'DEFAULT';
    return (

      <>
        {isTelephone && telemarketingCard ? (displayOptOutCard('Phone Calls'))
          : (
            <Card disablePadding disableGutters>
              <CardContent grow>
                <CardTitle
                  header={(
                    <Typography
                      variant="h5"
                      weight="base"
                      height="snug"
                      lineClamp="3"
                    >
                      {title}
                    </Typography>
                  )}
                  key={title}
                />
                <CardBody>
                  <Typography variant="body-base">{subText}</Typography>
                  {isLangPref && (
                    <Typography
                      variant="body-base"
                    />
                  )}
                </CardBody>
                <CardActions>
                  {isProXtra && !isLangPref && (
                    <Button
                      aria-label={learnMoreButton}
                      style={{
                        fontSize: 14,
                        textDecoration: 'underline'
                      }}
                      variant="text"
                      className="rounded-full"
                    >
                      Learn More
                    </Button>
                  )}
                </CardActions>
                <CardActions>
                  {determineButton(inputAttributes, checked, onChange, preferenceInput)}
                </CardActions>
              </CardContent>
            </Card>
          )}
      </>
    );
  };
}

function MarketingPreferencesCard({
  tableData, setTableData, setSelected, isProXtra, isLangPref, preferences, telemarketingCard
}) {
  const tableRow = TableRow(tableData, setTableData, setSelected, isProXtra,
    isLangPref, preferences, telemarketingCard);

  return (
    <div className="sui-grid sui-grid-cols-1 sm:sui-grid-cols-2 lg:sui-grid-cols-3 xl:sui-grid-cols-4 sui-gap-3">
      {Object.keys(tableData).map(tableRow)}
    </div>
  );
}

MarketingPreferencesCard.propTypes = {
  tableData: TableDataShape.isRequired,
  setTableData: PropTypes.func.isRequired,
  setSelected: PropTypes.func.isRequired,
  isProXtra: PropTypes.bool,
  isLangPref: PropTypes.bool,
  preferences: PropTypes.string,
  telemarketingCard: PropTypes.bool.isRequired,
};
const defaultProps = {
  isProXtra: false,
  isLangPref: false,
  preferences: '',
};
MarketingPreferencesCard.defaultProps = defaultProps;

export default MarketingPreferencesCard;
